import { DefaultActions, Separator, Showing, Total, Search, Wrapper } from '@/components/Grid/components/header/Heading';
import { GridProvider, useBuildGrid, DefaultGrid } from '@Components/Grid';

import { useSCAStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'

function SCAPromotionGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
  })

  return <DefaultGrid
    filters={null}
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions add={null} />
    </Wrapper>}
  />
}

export default function SCAPromotionGridLayout() {
  return <GridProvider store={useSCAStore()}>
    <SCAPromotionGrid />
  </GridProvider>
}
